import type { Strings } from './strings.js';

export const fr: Strings = {
  languageName: 'Français',
  welcome: 'Bienvenue',
  chooseReason: 'Comment pouvons-nous vous aider ?',
  back: 'Retour',
  cancel: 'Annuler',
  next: 'Suivant',
  submit: 'Envoyer',
  submitting: 'Envoi en cours',
  yourDetails: 'Vos informations',
  optional: 'facultatif',
  required: 'obligatoire',
  requiredHint: 'Merci de compléter les champs signalés.',
  fieldRequired: 'Veuillez compléter ce champ.',
  fieldInvalid: 'Veuillez vérifier cette information.',
  pleaseSelect: 'Veuillez choisir',
  search: 'Rechercher',
  noResults: 'Aucun résultat',
  noOptions: 'Aucun choix n’est disponible ici pour le moment. Veuillez vous adresser à l’accueil.',
  stepReason: 'Motif',
  stepDetails: 'Détails',
  stepDone: 'Terminé',
  thankYou: 'Merci !',
  submitted: 'Votre enregistrement a bien été transmis.',
  waitHint: 'Veuillez prendre place. Vous serez appelé sous peu.',
  scanFormHint: 'Scannez le code avec votre téléphone pour emporter le formulaire.',
  ticketNumber: 'Votre numéro d’attente est',
  queuedTitle: 'Merci !',
  queuedHint:
    'Votre enregistrement a été sauvegardé et sera transmis automatiquement. Veuillez prendre place.',
  errorTitle: 'Cela n’a malheureusement pas fonctionné',
  errorHint: 'Veuillez réessayer ou vous adresser à l’accueil.',
  tryAgain: 'Réessayer',
  startOver: 'Recommencer',
  closedTitle: 'Nos bureaux sont actuellement fermés',
  closedHint: 'Vous pouvez tout de même vous enregistrer - nous vous recontactons le prochain jour ouvré.',
  closedCallUs: 'Vous pouvez nous joindre au',
  continueAnyway: 'S’enregistrer quand même',
  appointmentQuestion: 'Avez-vous un rendez-vous ?',
  appointmentYes: 'Oui, j’ai un rendez-vous',
  appointmentNo: 'Non, je n’ai pas de rendez-vous',
  visitingWhom: 'Qui souhaitez-vous voir ?',
  privacyTitle: 'Protection des données',
  privacyAccept: 'J’ai lu les informations sur la protection des données.',
  privacyRequired: 'Veuillez confirmer les informations sur la protection des données.',
  offline: 'Hors ligne',
  offlineHint: 'Pas de connexion - les enregistrements sont sauvegardés et transmis plus tard.',
  pendingCount: 'enregistrement(s) en attente',
  idleWarning: 'Vos saisies vont être effacées dans un instant.',
  pairTitle: 'Connecter la tablette',
  pairHint: 'Veuillez saisir le code d’appairage fourni par l’administration.',
  pairPlaceholder: 'ABCD-1234',
  pairButton: 'Connecter',
  pairError: 'Ce code est invalide ou a expiré.',
  pairSuccess: 'Tablette connectée',
  loading: 'Chargement',
  notConfigured: 'Aucun type de visite configuré',
  notConfiguredHint: 'Veuillez vous adresser à l’accueil.',
  adminLink: 'Administration',
  pairCodeHint:
    'Le code est généré dans l’administration sous « Sites et tablettes » et n’est valable que pendant une durée limitée.',
  setupTitle: 'Pas encore configuré',
  setupText:
    'Ce système n’a pas encore été configuré. L’assistant crée l’administrateur, l’organisation, un site et la première tablette.',
  setupButton: 'Démarrer la configuration',
  setupAfter: 'Le champ du code d’appairage apparaîtra ensuite ici automatiquement.',
};
